import { render, staticRenderFns } from "./Cow-Card.vue?vue&type=template&id=58913b52&scoped=true&"
import script from "./Cow-Card.vue?vue&type=script&lang=js&"
export * from "./Cow-Card.vue?vue&type=script&lang=js&"
import style0 from "./Cow-Card.vue?vue&type=style&index=0&id=58913b52&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58913b52",
  null
  
)

export default component.exports